module.exports = __webpack_public_path__ + "img/Avatar-27.26946c35.svg";